import Vue from 'vue'

// url过滤器 
const urlFilter = (url, s) => {
	var baseUrl = 'https://files.sciconf.cn';
	if (!url) {
		url = 'https://files.sciconf.cn/mpweixin/dc1bd080-23e7-11eb-8a36-ebb87efcf8c0.jpg!wx360';
	} else if(url.indexOf('gif') != '-1') {
		//gif格式不加后缀
		return url;
	} else if (url.indexOf('wxfile:/') == -1) {
		url = url.replace('!avatar', '')
		url = url.replace('!wx250', '')
		if (url.indexOf('http') != -1) { // 全路径
			let ossFile = 'https://meetingfiles.oss-cn-qingdao.aliyuncs.com/';
			// 全路径拼接重复问题
			if(url.indexOf(ossFile + 'https') != -1){
				url = url.replace(ossFile,'');
			}else{
				url = url.indexOf(baseUrl) == -1 ? url : url + (s ? '!wx' + s : '');
			}
		} else if (url.indexOf('../') != -1) { // 本地图片
			url = url;
		} else if (url.indexOf('./') != -1) { // 相对路径
			url = baseUrl + url.replace('./', '') + (s ? '!wx' + s : '');
		} else { // 
			url = baseUrl + '/' + url + (s ? '!wx' + s : '');
		}
	}
	// 使用压缩图
	return url
}

//时间过滤器
const formatDate = (date, fmt) => {
	date = date || ''
	date = (typeof date == 'number') ? date : new Date(date.toString().replace(new RegExp('-', 'g'), '/'))
	date = date ? date : new Date()
	date = (typeof date == 'number') ? new Date(date) : date
	fmt = fmt || 'yyyy-MM-dd HH:mm:ss'
	var obj = {
		y: date.getFullYear(), // 年份，注意必须用getFullYear
		M: date.getMonth() + 1, // 月份，注意是从0-11
		d: date.getDate(), // 日期
		q: Math.floor((date.getMonth() + 3) / 3), // 季度
		w: date.getDay(), // 星期，注意是0-6
		H: date.getHours(), // 24小时制
		h: date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 12小时制
		m: date.getMinutes(), // 分钟
		s: date.getSeconds(), // 秒
		S: date.getMilliseconds(), // 毫秒
	}
	var week = ['日', '一', '二', '三', '四', '五', '六']
	var objKeys = ['y', 'M', 'd', 'q', 'w', 'H', 'h', 'm', 's', 'S']
	for (var i = 0; i < objKeys.length; i++) {
		var key = objKeys[i]
		fmt = fmt.replace(new RegExp(key + '+', 'g'), function(m) {
			var val = obj[key] + ''
			if (key == 'w') return (m.length > 2 ? '星期' : '周') + week[val]
			var len = val.length
			for (var j = 0; j < m.length - len; j++) val = '0' + val
			return m.length == 1 ? val : val.substring(val.length - m.length)
		})
	}
	return fmt
}

//换算本地时间
const formatDateLocal = (dateStr, timeStr,notYear) => {
	if (timeStr && dateStr) {
		let splits = timeStr.split('-');
		let startTime = dateStr + ' ' + splits[0];
		let endTime = dateStr + ' ' + splits[1];
		let startTimeNew = formatDate(startTime, 'HH:mm');
		endTime = formatDate(endTime, 'HH:mm');
		if (splits[0].length <= 1 || splits[1].length <= 1) {
			startTimeNew = splits[0];
			endTime = splits[1];
		}
		//年
		let year = formatDate(startTime, 'yyyy-MM-dd');
		if(notYear){
			return startTimeNew + '-' + endTime;
		}
		return year + ' ' + startTimeNew + '-' + endTime;
	}
}

/**
 * ## 保留两位小数，整数补0
 * @param {*} value
 * @returns
 */
const keepTwoDecimalFull = (value) => {
	var result = parseFloat(value);
	if (isNaN(result)) {
		// alert('传递参数错误，请检查！');
		return '0.00';
	}
	result = Math.round(value * 100) / 100;
	var s_x = result.toString(); //将数字转换为字符串
	var pos_decimal = s_x.indexOf('.'); //小数点的索引值
	// 当整数时，pos_decimal=-1 自动补0
	if (pos_decimal < 0) {
		pos_decimal = s_x.length;
		s_x += '.';
	}
	// 当数字的长度< 小数点索引+2时，补0
	while (s_x.length <= pos_decimal + 2) {
		s_x += '0';
	}
	return s_x;
}

/**
 * ## 货币类型
 * @param {*} value
 * @returns
 */
const currencyType = (value) => {
	if (value == 1) {
		return '￥'
	} else if (value == 2) {
		return '$'
	} else if (value == 3) {
		return '€'
	} else if (value == 4) {
		return 'HK$'
	} else if (value == 5) {
		return 'MOP$'
	}
}
Vue.prototype.$currencyType = currencyType;
Vue.prototype.$keepTwoDecimalFull = keepTwoDecimalFull;
Vue.prototype.$urlFilter = urlFilter;
Vue.filter('formatDate',formatDate);
Vue.filter('urlFilter',urlFilter);
Vue.filter('formatDateLocal',formatDateLocal);



